import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import "./NewMenu.css";

import history from "../../../../history";
import { getMeals } from "../../../../actions/mealActions";
import { getFullMenu, newMenu, editMenu, confirmMenu } from "../../../../actions/menuActions";

import Modal from "../../../CustomViews/Modal";

class NewMenu extends React.Component {
    constructor(props) {
        super(props);

        this.weekDays = [
            { name: "Poniedziałek", date: null },
            { name: "Wtorek", date: null },
            { name: "Środa", date: null },
            { name: "Czwartek", date: null },
            { name: "Piątek", date: null }
        ];
        this.initialState = {
            weekDaysReady: false,
            addOperations: {},
            updateOperations: {},
            deleteOperations: {},
            modal: false,
            errors: []
        };
        this.state = this.initialState;
    }

    componentDidMount() {
        this.props.getMeals();
        this.props.getFullMenu();
    }

    componentDidUpdate() {
        if (!this.state.weekDaysReady && this.props.fullMenu.dateFrom) {
            const dateFrom = new Date(this.props.fullMenu.dateFrom);
            this.weekDays[0].date = dateFrom.toISOString().slice(0, 10);
            for (let i = 1; i < 5; i++) {
                const date = new Date(dateFrom);
                date.setDate(date.getDate() + i);
                this.weekDays[i].date = date.toISOString().slice(0, 10);
            }
            this.setState({ weekDaysReady: true });
        }
    }

    onRowAdd = (weekDay, mealID) => {
        const tmpPosID = Math.max.apply(null, [0, ...Object.keys(this.state.addOperations)]) + 1;
        this.setState({ addOperations: { ...this.state.addOperations, [tmpPosID]: { tmpPosID, weekDay, mealID, description: "" } } });
    };

    onRowUpdate = (pos, value, isNew) => {
        if (isNew) this.setState({ addOperations: { ...this.state.addOperations,
            [pos.tmpPosID]: { ...this.state.addOperations[pos.tmpPosID], description: value }
        } });
        else this.setState({ updateOperations: { ...this.state.updateOperations,
            [pos.posID]: this.state.updateOperations[pos.posID] ? (
                JSON.stringify({ ...this.state.updateOperations[pos.posID], description: value }) !== JSON.stringify(pos) ?
                { ...this.state.updateOperations[pos.posID], description: value } : null
            ) : { ...pos, description: value }
        } });
    };

    onRowDelete = (pos, isNew) => {
        if (isNew) this.setState({ addOperations: Object.fromEntries(Object.entries(this.state.addOperations).filter(([key, _]) => +key !== pos.tmpPosID)) });
        else this.setState({
            deleteOperations: { ...this.state.deleteOperations, [pos.posID]: pos },
            updateOperations: { ...this.state.updateOperations, ...(this.state.updateOperations[pos.posID] ? { [pos.posID]: null } : {}) }
        });
    };

    onChangesApply = () => {
        document.activeElement.blur();
        const formValues = this.props.fullMenu.menuID ? {
            addOperations: [...Object.values(this.state.addOperations).filter(v => v !== null)],
            updateOperations: [...Object.values(this.state.updateOperations).filter(v => v !== null)],
            deleteOperations: [...Object.keys(this.state.deleteOperations).filter(k => this.state.deleteOperations[k] !== null).map(k => +k)]
        } : {
            dateFrom: this.props.fullMenu.dateFrom,
            dateTo: this.props.fullMenu.dateTo,
            details: [...Object.values(this.state.addOperations).filter(v => v !== null)]
        };
        if (this.props.fullMenu.menuID) this.props.editMenu(this.props.fullMenu.menuID, formValues, this.onError);
        else this.props.newMenu(formValues, this.onError);
    };

    onError = ({ data }) => {
        this.setState({ errors: data.error });
    };

    renderError = error => {
        return error ? (
            <div className="ui error message">
                {error.message.map((line, index) => <p key={index}>{line}</p>)}
            </div>
        ) : null;
    };

    renderModal = () => {
        if (this.state.modal) {
            return (
                <Modal
                    title="Zatwierdzenie menu"
                    content={<p>Czy na pewno chcesz zatwierdzić to menu? Po zatwierdzeniu menu nie będzie można go już edytować.</p>}
                    actions={(
                        <React.Fragment>
                            <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                            <button onClick={() => this.props.confirmMenu(this.props.fullMenu.menuID)} className="ui primary button">Zatwierdź</button>
                        </React.Fragment>
                    )}
                    onDismiss={() => history.go(0)}
                />
            );
        }
    };

    renderMenuForm = () => this.state.weekDaysReady ? this.weekDays.map((weekDay, index) => {
        const weekDayError = this.state.errors.filter(e => e.field === "details" && e.weekDay === index)[0];

        return (
            <div className="ui segment" key={index}>
                <div className="ui big header">
                    <div className="content">{weekDay.name} ({weekDay.date})</div>
                </div>
                {this.renderMealGroupsForm({ index, ...weekDay })}
                {this.renderError(weekDayError)}
            </div>
        );
    }) : null;

    renderMealGroupsForm = weekDay => this.props.meals.map((mealGroup => {
        return mealGroup.category ? (
            <React.Fragment key={mealGroup.mealID}>
                <div className="ui small header">
                    <div className="content">{mealGroup.description}</div>
                </div>
                <div className="ui segment">
                    <div className="ui grid">
                        {this.props.fullMenu.menuID && this.props.fullMenu.content[weekDay.date] ? this.renderRows(this.props.fullMenu.content[weekDay.date][mealGroup.mealID].rows, false) : null}
                        {this.renderRows(Object.values(this.state.addOperations).filter(p => p && p.weekDay === weekDay.index && p.mealID === mealGroup.mealID), true)}
                        <div className="one column row">
                            <div className="column">
                                <button className="ui button" onClick={() => this.onRowAdd(weekDay.index, mealGroup.mealID)}>Dodaj pozycję</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        ) : null;
    }));

    renderRows = (rows, isNew) => rows.map(pos => {
        const posError = this.state.errors.filter(e => e.field === "description" && ((isNew && e.tmpPosID === pos.tmpPosID) || (!isNew && e.posID === pos.posID)))[0];
        
        return isNew || !this.state.deleteOperations[pos.posID] ? (
            <div className="row" key={isNew ? pos.tmpPosID : pos.posID}>
                <div className="fourteen wide column">
                    <div className="ui form error warning">
                        <input
                            type="text"
                            value={!isNew && this.state.updateOperations[pos.posID] ? this.state.updateOperations[pos.posID].description : pos.description}
                            onChange={value => this.onRowUpdate(pos, value.target.value, isNew)}
                            placeholder="Wpisz nazwę potrawy..."
                        />
                        {this.renderError(posError)}
                    </div>
                </div>
                <div className="two wide column">
                    <button className="ui button" onClick={() => this.onRowDelete(pos, isNew)}>Usuń</button>
                </div>
            </div>
        ) : null;
    });

    render() {
        let formError = this.state.errors.filter(e => e.field === "details" && (e.weekDay === null || e.weekDay === undefined))[0];
        if (!formError && this.state.errors.length) formError = { field: "details", message: ["Formularz zawiera błędy"] };

        return (
            <React.Fragment>
                <div className="new-menu-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="active item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className="item">
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className="item">
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <div className="ui three item menu">
                            <Link to="/meal-reservations/my" className="item">
                                <div className="content">Moje rezerwacje</div>
                            </Link>
                            <Link to="/meal-reservations" className="item">
                                <div className="content">Rezerwacje pracowników</div>
                            </Link>
                            <Link to="/menus/edit" className="active item">
                                <div className="content">Edycja menu</div>
                            </Link>
                        </div>
                    ) : null}
                    <div className="ui divider" />
                    <div className="ui container">
                        <div className="ui large header">
                            <div className="content">Menu na tydzień od {this.props.fullMenu.dateFrom} do {this.props.fullMenu.dateTo}:</div>
                        </div>
                        {this.renderMenuForm()}
                        {this.renderError(formError)}
                        <button className={`ui ${this.props.fullMenu.menuID ? "" : "primary"} button`} onClick={this.onChangesApply}>Zapisz zmiany</button>
                        {this.props.fullMenu.menuID ? (
                            <button className="ui primary button" onClick={() => this.setState({ modal: true })}>Zatwierdź menu</button>
                        ) : null}
                    </div>
                </div>
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    meals: state.meal.list,
    fullMenu: state.menu.full
});

export default connect(mapStateToProps, { getMeals, getFullMenu, newMenu, editMenu, confirmMenu })(NewMenu);